import hljs from 'highlight.js/lib/core';
import React from 'react';
import xml from 'highlight.js/lib/languages/xml';
import json from 'highlight.js/lib/languages/json';
import css from 'highlight.js/lib/languages/css';
import javascript from 'highlight.js/lib/languages/javascript';
import clsx from 'clsx';
import 'highlight.js/styles/atom-one-light.css';
hljs.registerLanguage('xml', xml);
hljs.registerLanguage('json', json);
hljs.registerLanguage('css', css);
hljs.registerLanguage('javascript', javascript);

// languages: https://github.com/highlightjs/highlight.js/blob/main/SUPPORTED_LANGUAGES.md

export const TextHighlight = props => {
  const {
    children,
    languages
  } = props;
  const ref = React.useRef(null);
  const classes = React.useMemo(() => {
    var _languages$map;
    return (_languages$map = languages === null || languages === void 0 ? void 0 : languages.map(language => `language-${language}`)) !== null && _languages$map !== void 0 ? _languages$map : [];
  }, [languages]);
  const highlightCode = React.useCallback(() => {
    if (ref.current) {
      const nodes = ref.current.querySelectorAll('pre code');
      nodes.forEach(node => hljs.highlightElement(node));
    }
  }, [ref]);
  React.useLayoutEffect(() => {
    setTimeout(highlightCode, 0);
  }, []);
  return /*#__PURE__*/React.createElement("pre", {
    ref: ref
  }, /*#__PURE__*/React.createElement("code", {
    className: clsx(classes)
  }, children));
};